import { render } from "./AttendanceRecords.vue?vue&type=template&id=4627b533&scoped=true"
import script from "./AttendanceRecords.vue?vue&type=script&lang=js"
export * from "./AttendanceRecords.vue?vue&type=script&lang=js"

import "./AttendanceRecords.vue?vue&type=style&index=0&id=4627b533&scoped=true&lang=css"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4627b533"]])

export default __exports__